import React from "react";
import {Outlet} from "react-router-dom";
import Container from "../components/ui/Container";
import bg from "../assets/images/body-bg.jpg";

const RootLayout = () => {
    return (
        <main style={{backgroundImage: `url(${bg})`}}>
            <Container className="container py-5 px-5">
                <Outlet/>
            </Container>
            <footer className="mt-8 py-5 bg-light text-center">
                <p className="m-0 fw-light"><small>Copyright ⓒ 2025, 저작권자 All rights reserved.</small></p>
            </footer>
        </main>
    )
};

export default RootLayout;
